import { DTODesignTokenCreatePayload, DTODesignTokenListResponse, DTODesignTokenResponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class TokensEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  create(dsId: string, versionId: string, body: DTODesignTokenCreatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${versionId}/tokens`, DTODesignTokenResponse, {
      method: "POST",
      body,
    });
  }

  list(dsId: string, versionId: string): Promise<DTODesignTokenListResponse> {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/tokens`,
      DTODesignTokenListResponse
    );
  }

  get(dsId: string, versionId: string, tokenId: string): Promise<DTODesignTokenListResponse> {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/tokens/${tokenId}`,
      DTODesignTokenListResponse
    );
  }
}
